import React, { useEffect } from "react";
import styled from "styled-components";
import { FlexColumn } from "../../styles";
import MapComponent from "./MapComponent";
import MapButtonRow from "./map-button-row";
import PopupComponent from "./popup-components/PopupComponent";
import { useMapContext } from "./map-setup-context/MapContext";
import { MergedProjectResponse } from "./map-setup-context/InitialMapValues";

export const StyledWrapper = styled(FlexColumn)`
  height: auto;
  padding-left: 8px;
  padding-right: 8px;
  border-radius: 16px;
`;

export const Container = styled(FlexColumn)`
  border-radius: 16px;
  flex-wrap: wrap;
  margin-top: 8px;
  margin-bottom: 64px;
  width: 100%;
  height: 700px;
  background-color: white;
  @media (max-width: 800px) {
    height: 750px;
    margin-bottom: 0;
    margin-top: 12px;
    margin-bottom: 12px;
  }
`;

function Wrapper({ children }: { children: React.ReactNode }) {
  return (
    <StyledWrapper>
      <Container>{children}</Container>
    </StyledWrapper>
  );
}

function ImpactMap({ projects }: { projects: MergedProjectResponse[] }) {
  const { popupInfo, showPopup, setProjects: setMapProjects } = useMapContext();

  useEffect(() => {
    if (projects) {
      const filteredProjects = projects.filter(
        (project) =>
          project.centerCoordinates.lat !== 0 ||
          project.centerCoordinates.lon !== 0,
      );
      setMapProjects(filteredProjects);
    }
  }, [projects, setMapProjects, popupInfo]);

  if (projects.length === 0) return null;
  return (
    <Wrapper>
      <MapButtonRow />
      <MapComponent />
      {showPopup && <PopupComponent project={popupInfo} />}
    </Wrapper>
  );
}

export default ImpactMap;
